<template>
      <div class="cta">
        find out more
      </div>
</template>

<script>


export default {  
    components: {
     
    },
  name: 'cta',
}
</script>


<style scoped>

.cta {
  border: 2px solid #FFB95C;
  background-color: #FFB95C;
  color: #fff;
  border-radius: 30px;
  padding: 10px 32px 10px 32px;
  font-size: 24px;
  font-weight: 300;
  margin-top: 15px;
  display: inline;
}

@media screen and (min-width: 920px) {

.cta {
  margin-top: 40px;
}
}

</style>
